exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.editReservationPopupBg[data-v-2f691ee9] {\n  background-color: rgba(0, 0, 0, 0.5);\n  width: 100%;\n  height: 100%;\n  z-index: 20 !important;\n  position: absolute;\n}\n.editReservationPopupBg .popupArea[data-v-2f691ee9] {\n    width: 620px;\n    max-height: 100%;\n    max-width: 100%;\n    margin: 0 auto;\n}\n.editReservationPopupBg .popupArea .invoiceBookingsHolder[data-v-2f691ee9] {\n      max-height: 300px;\n      overflow-y: auto;\n}\n.invoiceLabel[data-v-2f691ee9] {\n  width: 100px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-2f691ee9","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/Invoice/InvoiceModal.vue
// module id = 1708
// module chunks = 0